export default __webpack_public_path__ + "static/media/Vashian Keffiyeh.1ea23a3d.jpg";